// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendor","shared"], () => (__webpack_require__("./node_modules/trendolizer-ui/build/index.css")))
__webpack_require__.O(undefined, ["vendor","shared"], () => (__webpack_require__("./public/css/app.css")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor","shared"], () => (__webpack_require__("./src/dashboard/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
